import { render, staticRenderFns } from "./stationVentBack.vue?vue&type=template&id=b072d85a&scoped=true"
import script from "./stationVentBack.vue?vue&type=script&lang=js"
export * from "./stationVentBack.vue?vue&type=script&lang=js"
import style0 from "./stationVentBack.vue?vue&type=style&index=0&id=b072d85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b072d85a",
  null
  
)

export default component.exports